import ROUTES from './paths'
import PAGE_TITLES from './titles'

export interface LinkProps {
  label: string
  link: string
}

export interface MenuItemProps {
  group?: string
  links: LinkProps[]
}

export const adminInstitutionMenuList: MenuItemProps[] = [
  {
    links: [
      {
        label: PAGE_TITLES.TERMS,
        link: ROUTES.TERMS
      },
      {
        label: PAGE_TITLES.PEOPLE,
        link: ROUTES.FACULTY_AND_STAFF
      },
      {
        label: PAGE_TITLES.COURSE_CATALOG,
        link: ROUTES.COURSE_CATALOG
      },
      {
        label: PAGE_TITLES.REPORTING_HIERARCHY,
        link: ROUTES.REPORTING_HIERARCHY
      }
    ]
  }
]

export const adminSettingsMenuList: MenuItemProps[] = [
  {
    links: [
      {
        label: PAGE_TITLES.ATTRIBUTES,
        link: ROUTES.ATTRIBUTES
      },
      {
        label: PAGE_TITLES.ACADEMIC_UNITS,
        link: ROUTES.ACADEMIC_UNITS
      },
      {
        label: PAGE_TITLES.EMAIL,
        link: ROUTES.EMAIL
      },
      {
        label: PAGE_TITLES.SIS_SYNC_LOGS,
        link: ROUTES.SIS_SYNC_LOGS
      },
      {
        label: PAGE_TITLES.INSTITUTION_SETTINGS,
        link: ROUTES.INSTITUTION_SETTINGS
      }
    ]
  }
]

export const adminSurveySetupMenuList: MenuItemProps[] = [
  {
    links: [
      {
        label: PAGE_TITLES.DISTRIBUTION_SERIES,
        link: ROUTES.DISTRIBUTION_SERIES
      },
      {
        label: PAGE_TITLES.MY_SURVEYS,
        link: ROUTES.SURVEYS
      }
    ]
  }
]
